import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Trophy } from 'lucide-react';
import { Rosemary } from './botanical/Rosemary';
import { Wildflower } from './botanical/Wildflower';
export function ProductReveal() {
  return <Section className="bg-forest-deep text-cream-warm text-center py-24 relative overflow-hidden" data-id="element-349">
      {/* Botanical Background Elements */}
      <Rosemary className="absolute -bottom-10 -left-10 w-64 h-64 text-moss opacity-20 blur-[1px] rotate-45" data-id="element-350" />
      <Wildflower className="absolute top-10 -right-5 w-48 h-48 text-honey opacity-10 blur-sm -rotate-12" data-id="element-351" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-352">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-honey/20 mb-6 border border-honey/30" data-id="element-353">
          <Trophy className="w-8 h-8 text-honey" data-id="element-354" />
        </div>
        <h2 className="text-4xl md:text-5xl font-serif font-bold text-cream-warm mb-4" data-id="element-355">
          🏆 HOGAR NATURAL™
        </h2>
        <p className="text-xl md:text-2xl text-sage-mist mb-6 font-medium" data-id="element-356">
          5 Tomos + 5 Bonos — Más de 80 protocolos naturales
        </p>
        <p className="text-3xl font-serif italic text-honey-light mb-12" data-id="element-357">
          Todo resuelto.
        </p>

        {/* Book mockup showcase */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative max-w-2xl mx-auto" data-id="element-358">
          {/* Golden spotlight glow */}
          <div aria-hidden="true" className="absolute inset-x-0 -top-10 h-40 bg-honey/30 blur-3xl rounded-full" data-id="element-359" />
          <img src="https://cdn.magicpatterns.com/uploads/9g9ftWJsteQG1r7DZ97kAX/portada_2_hogar_natural.png" alt="Hogar Natural en Casa — 5 Tomos digitales + 5 Bonos" className="relative w-full h-auto rounded-2xl shadow-[0_40px_80px_-20px_rgba(0,0,0,0.6),0_0_60px_-10px_rgba(212,162,76,0.4)] border border-honey/30" data-id="element-360" />
        </motion.div>
      </div>
    </Section>;
}